const PRO = 'PRO'
const CON = 'CON'

export { PRO, CON }
